import React from 'react';
import { valorParaGravar } from '../../lib/campos';

// Entradas dos campos customizados dentro do formulário do lead (roadmap #24).
function CamposCustom({ campos = [], valores = {}, onChange }) {
  if (!campos.length) return null;
  const inp = 'apple-input w-full px-3 py-2 text-sm';
  const set = (c, bruto) => onChange({ ...valores, [c.key]: valorParaGravar(c, bruto) });

  return <div className="rounded-2xl border border-black/[0.06] p-3 space-y-3">
    <p className="t-caption-2 text-gray-400 font-semibold">Campos desta empresa</p>
    <div className="grid sm:grid-cols-2 gap-3">
      {campos.map(c => {
        const v = valores?.[c.key];
        return <div key={c.key} className={c.tipo === 'selecao' || c.tipo === 'url' ? 'sm:col-span-2' : ''}>
          <label className="text-xs text-gray-500 font-medium mb-1 block" htmlFor={`custom-${c.key}`}>{c.label}</label>
          {c.tipo === 'selecao'
            ? <select id={`custom-${c.key}`} className={inp} value={v ?? ''} onChange={e=>set(c, e.target.value)}>
                <option value="">—</option>
                {(c.opcoes||[]).map(o=><option key={o} value={o}>{o}</option>)}
              </select>
            : c.tipo === 'simnao'
            ? <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer py-1.5">
                <input id={`custom-${c.key}`} type="checkbox" checked={v === true} onChange={e=>set(c, e.target.checked)} /> Sim
              </label>
            : <input id={`custom-${c.key}`} className={inp}
                type={c.tipo === 'data' ? 'date' : (c.tipo === 'numero' || c.tipo === 'moeda') ? 'number' : c.tipo === 'url' ? 'url' : 'text'}
                step={c.tipo === 'moeda' ? '0.01' : undefined}
                value={v ?? ''} onChange={e=>set(c, e.target.value)} />}
        </div>;
      })}
    </div>
  </div>;
}

export { CamposCustom };
